import request from "@/utils/request";
import type { CrossBrandBootstrapDto } from "../types";

export async function fetchCrossBrandBootstrap(
  includeClientDetect = false
): Promise<CrossBrandBootstrapDto | null> {
  try {
    const res = await request({
      url: "/v1/cross-brand/bootstrap",
      method: "get",
      params: { includeClientDetect },
    });
    const data = (res as { data?: CrossBrandBootstrapDto })?.data;
    if (!data?.config) return null;
    return data;
  } catch (e) {
    console.warn("[crossBrandHub] bootstrap failed", e);
    return null;
  }
}
